import ReviewContainer from './ReviewContainer';

export default ReviewContainer;



// WEBPACK FOOTER //
// ./src/components/pages/ReviewPage/index.js